import { render, staticRenderFns } from "./blueListItem.vue?vue&type=template&id=2ffd31fe&scoped=true&"
import script from "./blueListItem.vue?vue&type=script&lang=js&"
export * from "./blueListItem.vue?vue&type=script&lang=js&"
import style0 from "./blueListItem.vue?vue&type=style&index=0&id=2ffd31fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd31fe",
  null
  
)

export default component.exports